import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'How far in advance should we start planning?',
    answer: 'We recommend starting 9-12 months before your desired travel dates, especially for popular seasons. This gives you time to promote the trip and allows travelers to plan and budget effectively.'
  }, {
    question: 'What group sizes work best?',
    answer: 'Most of our group trips work well with 20-40 travelers, though we can accommodate groups from 10 to 50+. Larger groups often qualify for better pricing and more flexibility (like private coaches).'
  }, {
    question: 'Do you help us promote the trip to our members?',
    answer: "Absolutely! We provide customizable flyers, email templates, and trip summaries you can share. We'll also schedule a call or webinar to answer questions directly from your interested travelers."
  }, {
    question: 'How do payments work?',
    answer: "We work with you to set a deposit deadline and final payment date. Travelers can pay individually online or by check, and we provide a clear payment timeline for your group so you don't have to chase money."
  }, {
    question: 'Can we book online with a Web Code?',
    answer: 'Yes! If you already have a Web Code from a brochure or previous inquiry, you can book directly online. Otherwise, request a group proposal to get started.'
  }];
  return <section className="py-20 bg-white" data-id="element-1">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-primary text-center mb-12" data-id="element-3">
          Common questions
        </h2>

        <div className="space-y-4" data-id="element-4">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-5">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-6">
                <span className="font-bold text-primary text-lg" data-id="element-7">
                  {faq.question}
                </span>
                {openIndex === index ? <Minus className="text-teal flex-shrink-0" data-id="element-8" /> : <Plus className="text-teal flex-shrink-0" data-id="element-9" />}
              </button>

              <AnimatePresence data-id="element-10">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-11">
                    <div className="p-6 pt-0 text-gray-600 leading-relaxed border-t border-gray-100" data-id="element-12">
                      {faq.answer}
                      {index === 4 && <div className="mt-4" data-id="element-13">
                          <a href="#" className="text-teal font-medium hover:underline" data-id="element-14">
                            Book Now with Web Code →
                          </a>
                        </div>}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}